export default __webpack_public_path__ + "static/media/sublerTwitter-600x314.2eb26c50.png";